<template>
    <input
        type="tel"
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
        v-on:blur="$emit('filled-out', $event.target.value)"
    >
</template>

<script>
  export default {
    props: {
      field: {},
      value: '',
    },
  };
</script>
